(function(DS) {
  var splashSection = DS.$("#neat");
  var omSection = DS.$("#om");
  var produktSection = DS.$("#produkt");
  var kontaktSection = DS.$("#kontakt");

  var mobMenu = DS.$(".mob_menu");
  var mainHeader = DS.$('.main_header');

  // mobile menu
  mobMenu.onclick = function() {
    location.hash = "#mob";
    mainHeader.classList.toggle('mobile');
  };
  function locationHashChanged() {
    if(location.hash !== '#mob') {
      mainHeader.classList.remove('mobile');
    }
    ScrollCall.checkScroll(null, true);
  }
  window.onhashchange = locationHashChanged;

  window.addEventListener("load", function load(event){
    window.removeEventListener("load", load, false);

    if (splashSection.getBoundingClientRect().bottom < 0) {
      document.body.classList.add('scrolled');
    }
  }, false);

  // end mobile menu

  ScrollCall.addCall({
    selector : '.main_splash',
    onEnter: function (e, d) {
      document.body.classList.remove('scrolled');
    }
  }).addCall({
    selector : '.main_splash',
    offsetY : -200,
    onLeave: function (e, d) {
      document.body.classList.add('scrolled');
    }
  });

  ScrollCall.addCall({
    selector : 'section',
    onEnterHalf: function (e, d) {
      DS.$('#nav-' + e.obj.id).classList.add('active');
      DS.$('#nav-' + e.obj.id).classList.remove('hasBeenActive');
    },
    onLeaveHalf: function (e, d) {
      if(!DS.$('#nav-' + e.obj.id)) { return; }
      if (d == 'down') {
        DS.$('#nav-' + e.obj.id).classList.remove('active');
        DS.$('#nav-' + e.obj.id).classList.add('hasBeenActive');
      } else {
        DS.$('#nav-' + e.obj.id).classList.remove('active');
        DS.$('#nav-' + e.obj.id).classList.remove('hasBeenActive');
      }

    }
  });

  var navLinks = DS.$$('.main_header a');
  for (var i = navLinks.length - 1; i >= 0; i--) {
    navLinks[i].addEventListener('click', runScroll, false)
  };

  function runScroll(e) {
    // mainHeader.classList.remove('mobile');
    // scrollTo(DS.$(e.target.hash).offsetTop, 300);
    // e.preventDefault();
  }

  function scrollTo(to, duration) {
    if (duration < 0) return;
    var difference = to - document.body.scrollTop;
    var perTick = difference / duration * 10;

    setTimeout(function() {
        document.body.scrollTop = document.body.scrollTop + perTick;
        if (document.body.scrollTop === to) return;
        scrollTo(to, duration - 10);
    }, 10);
  }
})(DS);
